export default __webpack_public_path__ + "static/media/top-path.125b7e0e.svg";